import { Component, Input, OnInit } from '@angular/core';
import { LabRequestDetail, LabRequestHistory } from 'src/app/models';
import { LabRequestService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'bart-request-history',
  templateUrl: './request-history.component.html',
  styleUrls: ['./request-history.component.scss']
})
export class RequestHistoryComponent implements OnInit {
  @Input() labRequestId:number;
  @Input() print:boolean=false;
  public labRequestHistory:LabRequestHistory[]=[];
  constructor(private _waterLabService: LabRequestService, private _loaderService: LoaderService) { }

  ngOnInit() {
    this.getHistoryDetails()
  }
  getHistoryDetails()
  {
    this._loaderService.show()
    let historyRequestParam={
      GETLABREQUESTDETAIL: {
        LabRequestID:this.labRequestId 
    },
    GETLABREQUESTHISTORY: {
        LabRequestID:this.labRequestId
    }
    }

    this._waterLabService.getLabRequestHistory(historyRequestParam).subscribe((data)=>
    {
      this.labRequestHistory=data.history
      if(this.labRequestHistory && this.labRequestHistory.length)
      {
        this.labRequestHistory.sort((a, b) => b.RowOrder - a.RowOrder);
      }
    },
    (err) => 
    {
      this._loaderService.hide()
      console.log("Error While getting Lab Request History");
    });   
    
}
}
